import PropTypes from 'prop-types';

const Icons = ({ variant, color, className, id }) => {
  switch (variant) {
    case Icons.ADD: {
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M3 8H13" stroke={color || 'white'} strokeWidth="2" strokeLinecap="round" />
          <path d="M8 13L8 3" stroke={color || 'white'} strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    }
    case Icons.PROMO: {
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.0021 4.76322C10.8525 3.16145 13.1475 3.16145 13.9979 4.76322V4.76322C14.4619 5.63705 15.4398 6.108 16.4123 5.92589V5.92589C18.1948 5.59207 19.6257 7.38644 18.9036 9.04999V9.04999C18.5097 9.95752 18.7512 11.0158 19.4999 11.6625V11.6625C20.8723 12.848 20.3616 15.0855 18.6108 15.5582V15.5582C17.6556 15.816 16.9788 16.6647 16.94 17.6532V17.6532C16.8688 19.4654 14.801 20.4612 13.3398 19.387V19.387C12.5427 18.801 11.4573 18.801 10.6602 19.387V19.387C9.19899 20.4612 7.1312 19.4654 7.06 17.6532V17.6532C7.02116 16.6647 6.34439 15.816 5.38924 15.5582V15.5582C3.6384 15.0855 3.1277 12.848 4.50008 11.6625V11.6625C5.24876 11.0158 5.4903 9.95752 5.09637 9.04999V9.04999C4.37427 7.38644 5.80522 5.59207 7.58775 5.92589V5.92589C8.56018 6.108 9.53814 5.63705 10.0021 4.76322V4.76322Z"
            stroke={color || '#FF576D'}
            strokeWidth="2"
            strokeLinejoin="round"
          />
          <path d="M14 9L10 15" stroke={color || '#FF576D'} strokeWidth="2" strokeLinecap="round" />
          <circle cx="9" cy="10" r="1" fill={color || '#FF576D'} stroke={color || '#FF576D'} />
          <circle cx="15" cy="14" r="1" fill={color || '#FF576D'} stroke={color || '#FF576D'} />
        </svg>
      );
    }
    case Icons.ARCHIVE: {
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.04415 6.03551L3.80132 12.764C3.76733 12.866 3.75 12.9728 3.75 13.0802V17.3346C3.75 18.4392 4.64543 19.3346 5.75 19.3346H18.25C19.3546 19.3346 20.25 18.4392 20.25 17.3346V13.0802C20.25 12.9728 20.2327 12.866 20.1987 12.764L17.9558 6.03551C17.6836 5.21883 16.9193 4.66797 16.0585 4.66797H7.94152C7.08066 4.66797 6.31638 5.21883 6.04415 6.03551Z"
            stroke={color || '#747475'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.5835 10.168H8.79183V10.6263C8.79183 12.3982 10.2282 13.8346 12.0002 13.8346V13.8346C13.7721 13.8346 15.2085 12.3982 15.2085 10.6263V10.168H18.4168"
            stroke={color || '#747475'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    }
    case Icons.PROMO_BIG: {
      return (
        <svg
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.672 12.6993C28.9397 8.42793 35.0599 8.42793 37.3277 12.6993V12.6993C38.5648 15.0295 41.1727 16.2854 43.7658 15.7998V15.7998C48.5192 14.9096 52.3351 19.6946 50.4095 24.1307V24.1307C49.359 26.5508 50.0031 29.3727 51.9996 31.0974V31.0974C55.6593 34.2587 54.2974 40.2255 49.6285 41.4859V41.4859C47.0815 42.1735 45.2767 44.4365 45.1732 47.0727V47.0727C44.9833 51.905 39.4692 54.5605 35.5728 51.696V51.696C33.4471 50.1334 30.5526 50.1334 28.4269 51.696V51.696C24.5305 54.5605 19.0164 51.905 18.8265 47.0727V47.0727C18.7229 44.4365 16.9182 42.1735 14.3712 41.4859V41.4859C9.70224 40.2255 8.34037 34.2587 12 31.0974V31.0974C13.9965 29.3727 14.6406 26.5508 13.5901 24.1307V24.1307C11.6645 19.6946 15.4804 14.9096 20.2338 15.7998V15.7998C22.827 16.2854 25.4349 15.0295 26.672 12.6993V12.6993Z"
            stroke={color || '#AAABAB'}
            strokeWidth="4"
            strokeLinejoin="round"
          />
          <path
            d="M37.3332 24L26.6665 40"
            stroke={color || '#AAABAB'}
            strokeWidth="4"
            strokeLinecap="round"
          />
          <circle
            cx="24"
            cy="26.6641"
            r="2.66667"
            fill={color || '#AAABAB'}
            stroke={color || '#AAABAB'}
            strokeWidth="2.66667"
          />
          <circle
            cx="40"
            cy="37.3359"
            r="2.66667"
            fill={color || '#AAABAB'}
            stroke={color || '#AAABAB'}
            strokeWidth="2.66667"
          />
        </svg>
      );
    }
    case Icons.CALENDAR: {
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.25 6H6.75C5.7835 6 5 6.7835 5 7.75V18.25C5 19.2165 5.7835 20 6.75 20H17.25C18.2165 20 19 19.2165 19 18.25V7.75C19 6.7835 18.2165 6 17.25 6Z"
            stroke="#747475"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.5 4.5V7.5"
            stroke="#747475"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.5 4.5V7.5"
            stroke="#747475"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5 11H19"
            stroke="#747475"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    }
    case Icons.HAMBURGER: {
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
          id={id}
        >
          <circle cx="5" cy="12" r="2" />
          <circle cx="12" cy="12" r="2" />
          <circle cx="19" cy="12" r="2" />
        </svg>
      );
    }
    case Icons.EDIT: {
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.00195 20.0013H8.00195L18.502 9.50128C19.0324 8.97085 19.3304 8.25142 19.3304 7.50128C19.3304 6.75113 19.0324 6.03171 18.502 5.50128C17.9715 4.97085 17.2521 4.67285 16.502 4.67285C15.7518 4.67285 15.0324 4.97085 14.502 5.50128L4.00195 16.0013V20.0013Z"
            stroke="#FF576D"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.5 6.50073L17.5 10.5007"
            stroke="#FF576D"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    }
    default:
      return null;
  }
};

Icons.ADD = 'add';
Icons.PROMO = 'promo';
Icons.ARCHIVE = 'archive';
Icons.PROMO_BIG = 'promo_big';
Icons.CALENDAR = 'calendar';
Icons.HAMBURGER = 'hamburger';
Icons.EDIT = 'edit';

Icons.propTypes = {
  variant: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.string,
};

Icons.defaultProps = {
  variant: '',
  color: '',
  className: '',
  id: '',
};

export default Icons;
